"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _Body = _interopRequireDefault(require("../../../text/Body"));

var _Heading = _interopRequireDefault(require("../../../text/Heading5"));

var _Notification = _interopRequireDefault(require("../../../feedback/Notification"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StyledNotification = (0, _styledComponents["default"])(_Notification["default"]).withConfig({
  componentId: "u6dihd-0"
})(["width:450px;"]);

var PhoneNumberNotification = function PhoneNumberNotification(_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      phoneNumber = _ref.phoneNumber;
  return isOpen && phoneNumber && _react["default"].createElement(StyledNotification, {
    className: className,
    isOpen: isOpen,
    title: "Special Discount",
    iconName: "dollarCircle"
  }, _react["default"].createElement(_Body["default"], {
    subdued: true
  }, "Want to save more? Book by phone."), _react["default"].createElement(_pclnDesignSystem.Flex, {
    mt: 2
  }, _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: "Phone",
    mr: 2
  }), _react["default"].createElement(_Heading["default"], null, "Call ", phoneNumber)));
};

PhoneNumberNotification.displayName = 'PhoneNumberNotification';
PhoneNumberNotification.propTypes = {
  className: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool.isRequired,
  phoneNumber: _propTypes["default"].string
};
PhoneNumberNotification.defaultProps = {
  className: '',
  isOpen: true
};
var _default = PhoneNumberNotification;
exports["default"] = _default;